import React from 'react';
import { string, bool } from 'prop-types';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

import { useIntl } from '../../util/reactIntl';
import * as validators from '../../util/validators';
import { Form, FieldTextInput, Icon, PrimaryButtonInline } from '../../components';

import css from './NewsletterForm.module.css';

/**
 * The footer's "Stay in the loop" field: an email field on the dark footer with the arrow button
 * inside it. The field has no visible label on the board, so its placeholder ("Your e-mail") also
 * names it for screen readers, and the arrow button is named "Subscribe".
 */
const NewsletterForm = props => {
  const intl = useIntl();
  return (
    <FinalForm
      {...props}
      render={fieldRenderProps => {
        const { rootClassName, className, formId, handleSubmit, inProgress } = fieldRenderProps;

        const emailPlaceholder = intl.formatMessage({ id: 'NewsletterForm.emailPlaceholder' });
        const emailRequired = validators.required(
          intl.formatMessage({ id: 'NewsletterForm.emailRequired' })
        );
        const emailValid = validators.emailFormatValid(
          intl.formatMessage({ id: 'NewsletterForm.emailInvalid' })
        );

        return (
          <Form
            className={classNames(rootClassName || css.root, className)}
            onSubmit={handleSubmit}
            noValidate
          >
            <FieldTextInput
              className={css.field}
              inputRootClass={css.input}
              helpClassName={css.help}
              type="email"
              name="email"
              autoComplete="email"
              id={formId ? `${formId}.email` : 'newsletterEmail'}
              placeholder={emailPlaceholder}
              aria-label={emailPlaceholder}
              validate={validators.composeValidators(emailRequired, emailValid)}
            />
            <PrimaryButtonInline
              className={css.submit}
              spinnerClassName={css.spinner}
              type="submit"
              inProgress={inProgress}
              disabled={inProgress}
              aria-label={intl.formatMessage({ id: 'NewsletterForm.submit' })}
            >
              {inProgress ? null : <Icon name="arrowRight" size={24} />}
            </PrimaryButtonInline>
          </Form>
        );
      }}
    />
  );
};

NewsletterForm.defaultProps = {
  rootClassName: null,
  className: null,
  formId: null,
  inProgress: false,
};

NewsletterForm.propTypes = {
  rootClassName: string,
  className: string,
  formId: string,
  inProgress: bool,
};

export default NewsletterForm;
